import React from "react";
import styled from "styled-components";

export const NoSuggestions = () => {
  return (
    <Container className="text-center">
      <h3 className="mt-4">No Suggestions</h3>
      <div className="mt-3">There is no suggestions for this field.</div>
      <div>Please, manually enter this field's data on the right.</div>
      <i>Tip: Press 0 to enter manual entry if needed.</i>
    </Container>
  );
};

const Container = styled.div`
  padding-top: 120px;
  color: #aaa;
  font-size: 14px;
  h3 {
    font-size: 24px;
  }
`;
